import { render, staticRenderFns } from "./client-reservation-list.vue?vue&type=template&id=d7ec6ee4&scoped=true&"
import script from "./client-reservation-list.vue?vue&type=script&lang=js&"
export * from "./client-reservation-list.vue?vue&type=script&lang=js&"
import style0 from "./client-reservation-list.vue?vue&type=style&index=0&id=d7ec6ee4&lang=scss&scoped=true&"
import style1 from "./client-reservation-list.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./client-reservation-list.vue?vue&type=style&index=2&id=d7ec6ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ec6ee4",
  null
  
)

export default component.exports
import {QScrollArea,QInfiniteScroll,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QInfiniteScroll,QIcon})
